import React from 'react';
import Header from './../../components/header';
import BusinessBody from './body';
import Footer from '../../components/footer';

function Business(props) {
    document.title = `Yebokenny Business List`;
    return (
        <div>
            <Header></Header>
            <BusinessBody></BusinessBody>
            <Footer></Footer>
        </div>
    );
}

export default Business;